import { WrapEmailType } from '../interface/interface';

export const WrapEmail: WrapEmailType = ({ email, className }) => {
  let emailArray;
  if (typeof email === 'string' && email.includes('@')) {
    emailArray = email.split('@');
  }
  return (
    <div className={`flex flex-wrap ${className}`}>
      {emailArray !== undefined ? (
        <>
          <div className="break-all">{emailArray[0]}</div>
          <div className="break-all">{`@${emailArray[1]}`}</div>
        </>
      ) : (
        '-'
      )}
    </div>
  );
};
